import * as React from "react";

import {type IconSize} from "@khanacademy/wonder-blocks-icon";
import {sizing} from "@khanacademy/wonder-blocks-tokens";
import {faceIconColor} from "@khan/auth-shared";

/**
 * Microsoft icon component that renders a Microsoft logo SVG.
 */
export const MicrosoftIcon = ({
    disabled = false,
    ariaHidden,
    size,
}: {
    // Whether the icon should appear disabled
    disabled: boolean;
    // Whether the icon should be hidden from screen readers
    ariaHidden: boolean;
    // The size of the icon.  Uses Wonder Blocks icon sizing ("small", "medium", "large", "xlarge")
    size?: IconSize;
}): React.ReactElement<React.ComponentProps<"svg">> => {
    const fadeFn = faceIconColor(disabled);

    // Convert size string to Wonder Blocks sizing token
    const sizeMap = {
        small: sizing.size_160,
        medium: sizing.size_240,
        large: sizing.size_320,
        xlarge: sizing.size_400,
    };
    const iconSize = size ? sizeMap[size] : sizeMap.medium;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            aria-hidden={ariaHidden}
            viewBox="0 0 23 23"
            width={iconSize}
            height={iconSize}
        >
            <path fill={fadeFn("#f3f3f3")} d="M0 0h23v23H0z" />
            <path fill={fadeFn("#f35325")} d="M1 1h10v10H1z" />
            <path fill={fadeFn("#81bc06")} d="M12 1h10v10H12z" />
            <path fill={fadeFn("#05a6f0")} d="M1 12h10v10H1z" />
            <path fill={fadeFn("#ffba08")} d="M12 12h10v10H12z" />
        </svg>
    );
};
